<!-- ===== Header ===== -->
<div class="card shadow-sm border-0 mb-3">
  <div class="card-body py-3">
    <h4 class="card-title mb-0 fw-semibold">
      {{ 'MENU.DASHBOARD.AddOnBoarding' | translate }}
    </h4>
  </div>

<!-- ===== Form Card ===== -->
<div class="card shadow-sm border-0">
  <div class="card-body">

    <form (ngSubmit)="onSubmit()" enctype="multipart/form-data">

      <div class="row justify-content-center">

        <div class="col-lg-8">

          <!-- Title -->
          <div class="mb-3">
            <label class="form-label fw-medium">
              {{ 'MENU.DASHBOARD.Title' | translate }}
            </label>

            <input
              type="text"
              class="form-control"
              placeholder="{{ 'MENU.DASHBOARD.Title' | translate }}"
              [(ngModel)]="formData.title"
              name="title"
              required
            />

            <small class="text-danger" *ngIf="errors?.title">
              {{ errors.title[0] }}
            </small>
          </div>

          <!-- Description -->
          <div class="mb-3">
            <label class="form-label fw-medium">
              {{ 'MENU.DASHBOARD.Description' | translate }}
            </label>

            <textarea
              class="form-control"
              rows="4"
              placeholder="{{ 'MENU.DASHBOARD.Description' | translate }}"
              [(ngModel)]="formData.description"
              name="description"
              required
            ></textarea>

            <small class="text-danger" *ngIf="errors?.description">
              {{ errors.description[0] }}
            </small>
          </div>

          <!-- Image -->
          <div class="mb-4">
            <label class="form-label fw-medium">
              {{ 'MENU.DASHBOARD.Image' | translate }}
            </label>

            <input
              type="file"
              class="form-control"
              accept="image/png, image/jpeg"
              (change)="onFileSelected($event)"
              name="image"
              required
            />

            <small class="text-danger" *ngIf="errors?.image">
              {{ errors.image[0] }}
            </small>
          </div>

          <!-- Submit -->
          <div class="d-flex justify-content-end">
            <button type="submit" class="btn btn-primary px-4">
              {{ 'MENU.DASHBOARD.Add' | translate }}
            </button>
          </div>

        </div>
      </div>

    </form>

  </div>
</div>
</div>
